import Constant from '../../../common/constant/Constant';
import { TmpHiddenSysfieldInCreateTicket, TmpHiddenSysFieldInTicketDetail, systemField } from '@/common/constant/SystemField';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { copyFileOfTicketDraftTo, createDataListFileDuplicate, getFormFieldData, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { validateErrorTicket, validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { getPublicRangeName, getSystemFieldNameInDrillDown, isDisplayOptionSearchSynonym, emailTicketOriginName } from '@/component/ticketKnowledge/handler/DrilldownAndDetailSearchHandler';
import {
    getFormById,
    getFormByIdWithoutAuthen,
    getFormListByProject,
    getFieldListInForm,
    getFormFieldWithCondition,
    getTagItemsByParentFieldIds,
    getTagItemsByParentFieldId
} from '@/service/formManagementService';
import { getCorporationById } from '@/service/organizationService';
import {
    getProjectById,
    getAllProjectListInCorporation,
    getActiveB2BCustomerProjectListOfProject
} from '@/service/projectService';
import {
    createTicketRecord,
    uploadTicketFileToS3,
    getTicketById,
    createNewTicketAPI,
    editTicketData,
    saveDraftTicketAPI,
    queryListMasterKnowledgeTicketOfForm
} from '@/service/ticketService';
import { getUserById } from '@/service/userService';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import { isInputAllFieldRequired } from './CreateTicketCommonHandler';
import { getLiveOrArchivedNameInDrillDown } from './HelpDeskTicketListHandler';
import { getAdditionalPermissionsForSave } from './SettingPermissionHandler';
import { getFormFromFormListById, getListCustomFiledOfForm, getRichTextFieldContent, unregisterField, sortListByOrder } from './TicketHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { reloadPanelAfterSoftDeleteTicketKnowledge } from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { isDisplaySplitPDF } from '@/component/formManagement/handler/FormListHandler';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { getBookmarkById } from '@/service/bookmarkService';
import _ from "lodash"

export const createKnowledgeTicketHandler = async (
    tabId,
    panelType,
    formData,
    userDetail,
    corporationDetail,
    panelId,
    argsAll,
    fieldListData,
    aiAutoSelectedData
) => {
    // check selectedForm
    if (Utils.isEmptyString(argsAll.selectedForm)) {
        argsAll.setIsErrorSelected(true);
        return;
    }

    let viewPermissions = argsAll.viewPermissions;
    let editPermissions = argsAll.editPermissions;
    let additionalViewPermissions = argsAll.additionalViewPermissions;
    let additionalEditPermissions = argsAll.additionalEditPermissions;
    let chatPermission = argsAll.chatPermission;

    if(Utils.isEmptyArray(viewPermissions) || Utils.isEmptyArray(editPermissions) || Utils.isEmptyString(chatPermission)) {
        return;
    }

    argsAll.setIsLoading(true);

    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === "WORKFLOW");
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData, aiAutoSelectedData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields)) {
        argsAll.setIsLoading(false);
        return;
    }

    // validate
    if (validateErrorTicket(argsAll, fields)) {
        argsAll.setIsLoading(false);
        return;
    }

    let ticketType = Constant.TICKET_TYPE.KNOWLEDGE;
    let formListClone = cloneDeep(argsAll.formList);
    let formSelectedId = argsAll.selectedForm;
    let formIndex = Utils.findIndexInArrayById(formSelectedId, formListClone);
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        if(formDetail.type === Constant.FORM_TYPE.FORM_MASTER) {
            ticketType = Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        }
    }

    let viewPermissionsSave = viewPermissions.map(p => p.value);
    let editPermissionsSave = editPermissions.map(p => p.value);
    let additionalViewPermissionsSave = getAdditionalPermissionsForSave(additionalViewPermissions);
    let additionalEditPermissionsSave = getAdditionalPermissionsForSave(additionalEditPermissions);

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
    );

    let fileUploadedDeleted = [];
    if(!Utils.isEmptyArray(argsAll.fileUpdatedList)) {
        fileUploadedDeleted = argsAll.fileUpdatedList.filter(file => file.isDelete === true);
        if(!Utils.isEmptyArray(fileUploadedDeleted)) {
            fileUploadedDeleted = fileUploadedDeleted.map(file => {
                let fileClone = {...file};
                delete fileClone.isDelete;
                delete fileClone.createdAt;
                delete fileClone?.thumbnailInfo;
                return fileClone
            })
        }
    }

    let newFileUpdatedList = cloneDeep(argsAll.fileUpdatedList);
    if(!Utils.isEmptyArray(newFileUpdatedList)) {
        newFileUpdatedList = newFileUpdatedList.map(file => {
            let fileClone = {...file};
            delete fileClone?.isPrivate;
            return fileClone
        })
    }

    if (Utils.isEmptyArray(uploadFileS3Result.fileListSuccess) && Utils.isEmptyObject(uploadFileS3Result.suffixOfAttachments)) {
        let {suffixOfAttachments, listFileUploadSuccess} = createDataListFileDuplicate(newFileUpdatedList);
        uploadFileS3Result.suffixOfAttachments = suffixOfAttachments;
        newFileUpdatedList = listFileUploadSuccess;
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft && !argsAll?.isDuplicate ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(newFileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id && !argsAll?.isDuplicate ? argsAll?.detailTicket?.id : '',
        fileUploadedDeleted: fileUploadedDeleted
    };

    let requestBody = {
        createTicketRequestDto: {
            outline: formData.outline,
            corporationOrigin: corporationDetail.id,
            description: formData.description,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail?.id,
            projectTarget: argsAll.projectInuseDetail?.id,
            corporationTarget: corporationDetail.id,
            ticketType: ticketType,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: argsAll.projectInuseDetail?.id,
            status: status,
            fields: fields,
            type: argsAll.selectedForm,
            customer: Constant.NA,
            viewPermission: viewPermissionsSave,
            additionalViewPermission: JSON.stringify(additionalViewPermissionsSave),
            editPermission: editPermissionsSave,
            additionalEditPermission: JSON.stringify(additionalEditPermissionsSave),
            chatPermission: chatPermission,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            sessionId: localStorageUtil.getSessionBrowserId(),
            isServicesPDFOfCorpOn: isDisplaySplitPDF(corporationDetail, Constant.FORM_TYPE.FORM_KNOWLEDGE),
            ...draftTicketInfo
        },
    };

    // call API create ticket
    let newTicket = await createNewTicketAPI(argsAll.API, requestBody);

    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        if (newTicket.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        }
        
        if (newTicket.errorMessage === Constant.MSG_SD_DUPLICATED_SCRIPT_TITLE) {
            const outlineField = fieldListData?.find(
                field => field.sysField?.toLowerCase() === Constant.SYS_FIELD.OUTLINE
            );

            if (outlineField) {
                argsAll.setErorsCreateKnowledgeTicket(outlineField.id, {
                    type: 'isValidDuplicateTitle',
                    message: I18n.get('MSG-SD-DUPLICATED-SCRIPT-TITLE')
                });
            }
        }
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE,
        formId: argsAll?.selectedForm,
        projectTargetId: argsAll?.projectInuseDetail?.id,
        corpTargetId: corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: argsAll.corporationDetail,
        rootProjectDetail: argsAll.projectInuseDetail,
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            additionalViewPermissions: argsAll.additionalViewPermissions,
            viewPermissions: viewPermissionsSave,
            ticketType,
        },
        isCreateKnowledge: true,
        isCreateCSV: false,
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }

    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);

    //update usingTicket of formList 
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        let usingTickets = Utils.convertJSONDataToObject(formDetail.usingTickets);

        if (!Utils.isEmptyObject(usingTickets)) {
            if (usingTickets[newTicket.affiliationProject]) {
                usingTickets[newTicket.affiliationProject].push(newTicket.id);
            } else {
                usingTickets[newTicket.affiliationProject] = [newTicket.id];
            }
        } else {
            usingTickets = {};
            usingTickets[newTicket.affiliationProject] = [newTicket.id];
        }

        formListClone[formIndex].usingTickets = JSON.stringify(usingTickets);
    }
    argsAll.setFormList(formListClone);

    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });
    
    argsAll.enqueueSnackbar(
        I18n.get(draftTicketInfo.isSendDraft ? 'MSG-CM-PUBLISH-DRAFT-CONTENT-SUCCESSFULLY': 'MSG-CM-CREATE-TICKET-SUCCESS'),
        {variant: 'success', autoHideDuration: 3000}
    );
    return;
};

export const handleOnchangePublicRange = (publicRangeSelected, argsAll) => {
    let newPublicRange = publicRangeSelected;
    if (newPublicRange === argsAll.selectedPublicRange) {
        return;
    }
    // argsAll.setSelectedPublicRange(newPublicRange);
    argsAll.setValueCreateKnowledgeTicket('publicRange', newPublicRange);
};

export const initDataPanelCreateTicketKnowledge = async (currentPanelInitDataRes, argsAll) => {
    let oldArgsAll = currentPanelInitDataRes.argsAll;
    argsAll.isLastActive = true;
    //selected form
    if (oldArgsAll.selectedForm) {
        await onConfirmChangeForm(oldArgsAll.selectedForm, argsAll);
    }

    let additionalViewPermission = getAdditionalPermissionsForSave(oldArgsAll.additionalViewPermissions)
    let additionalEditPermission = getAdditionalPermissionsForSave(oldArgsAll.additionalEditPermissions)

    let dataSettingDefault = {
        viewPermission: oldArgsAll.viewPermissions?.map(p => p.value),
        editPermission: oldArgsAll.editPermissions?.map(p => p.value),
        additionalViewPermission: JSON.stringify(additionalViewPermission),
        additionalEditPermission: JSON.stringify(additionalEditPermission),
        chatPermission: oldArgsAll.chatPermission
    };
    await argsAll.setDataSettingDefaults(dataSettingDefault);

    //open publicRange
    if(oldArgsAll.selectedPublicRange) {
        await handleOnchangePublicRange(oldArgsAll.selectedPublicRange, argsAll)
    }

    // File upload
    let fileUploadListOld = oldArgsAll.fileUploadList;
    if (!Utils.isEmptyArray(fileUploadListOld)) {
        argsAll.setFileUploadList(fileUploadListOld);
        argsAll.setValueCreateKnowledgeTicket(
            'fileUploadList',
            fileUploadListOld
        );
    }

    if (oldArgsAll?.aiAutoSelectedData && argsAll?.setAIAutoSelectedData) {
        await Utils.delay(1000);
        argsAll?.setAIAutoSelectedData(oldArgsAll?.aiAutoSelectedData);
    }
}

/**
 * get Drilldow nData Selected
 * @param {*} API 
 * @param {*} viewStructure 
 * @param {*} setDrillDownDataSelected 
 * @returns 
 */
export const getDrilldownDataSelected = async (API, viewStructure, setDrillDownDataSelected, authen = true) => {
    viewStructure = Utils.convertJSONDataToObject(viewStructure);
    if (Utils.isEmptyArray(viewStructure.fields) && Utils.isEmptyArray(viewStructure.statusFields) && Utils.isEmptyArray(viewStructure.tagFields) && Utils.isEmptyArray(viewStructure.privateBookmark) && Utils.isEmptyArray(viewStructure.sharedBookmark)
    ) {
        setDrillDownDataSelected([]);
        return;
    }
    
    let allDrilldownSelectedData = await getDrilldownItemDataSelected(API, viewStructure, authen);
    setDrillDownDataSelected(allDrilldownSelectedData);
};

/**
 * get Drilldown Item Selected
 * @param {*} argsCommon 
 * @returns 
 */
export const getDrilldownItemDataSelected = async (API, viewStructure, authen = true) => {
    let systemFieldList = viewStructure.fields || [];
    let statusFieldList = viewStructure.statusFields || [];
    let tagFieldList = viewStructure.tagFields || [];
    let privateBookmark = viewStructure.privateBookmark || [];
    let sharedBookmark = viewStructure.sharedBookmark || []

    let dataDrilldownSelected = [];
    if (!Utils.isEmptyArray(systemFieldList)) {
        await Promise.all(
            systemFieldList.map(async (field) => {
                let fieldId = !Utils.isEmptyArray(Object.keys(field)) ? Object.keys(field)[0] : '';
                if (
                    fieldId &&
                    [
                        Constant.DRILLDOWN_TYPE_TEXT.FORM,
                        Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE,
                        Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN,
                        Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET,
                        Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER,
                        Constant.DRILLDOWN_TYPE_TEXT.CREATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.UPDATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER,
                        Constant.DRILLDOWN_TYPE_TEXT.PUBLIC_RANGE,
                        Constant.DRILLDOWN_TYPE_TEXT.LIVE_OR_ARCHIVED,
                        Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE,
                        Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN
                    ].includes(fieldId)
                ) {
                    let labelName = '';
                    let itemSelected = field[fieldId];
                    let order = 0;
                    if (!itemSelected) {
                        return;
                    }

                    switch (fieldId) {
                        case Constant.DRILLDOWN_TYPE_TEXT.FORM: {
                            let formData = authen ? await getFormById(API, itemSelected) : await getFormByIdWithoutAuthen(API, itemSelected);
                            if (!Utils.isEmptyObject(formData)) {
                                labelName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, formData.name);
                                order = 1;
                            }
                            break;
                        }
                        case Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE:
                            labelName = itemSelected;
                            order = 7;
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN:
                        case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET:
                            labelName = await getProjectNameDrillDownDataSelected(API, itemSelected);
                            switch (fieldId) {
                                case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN:
                                    order = 1.1;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET:
                                    order = 1.2;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER:
                        case Constant.DRILLDOWN_TYPE_TEXT.CREATOR:
                        case Constant.DRILLDOWN_TYPE_TEXT.UPDATOR:
                        case Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER:
                        case Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE:
                            if (itemSelected === Constant.ANONYMOUS_USER_ID) {
                                labelName = I18n.get('USER04LB052');
                            } else {
                                labelName = await getUserNameDrillDownDataSelected(API, itemSelected);
                            }

                            switch (fieldId) {
                                case Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER:
                                    order = 2.9;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.UPDATOR:
                                    order = 3;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER:
                                    order = 4;
                                    break;
                                default:
                                    order = 2;
                                    break;
                            }
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.PUBLIC_RANGE:
                            labelName = getPublicRangeName(itemSelected);
                            order = 5;
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.LIVE_OR_ARCHIVED:
                            labelName = getLiveOrArchivedNameInDrillDown(itemSelected);
                            order = 5;
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN:
                            labelName = emailTicketOriginName(itemSelected);
                            order = 6;
                            break;
                        default:
                            break;
                    }
        
                    dataDrilldownSelected.push({
                        id: fieldId,
                        itemId: itemSelected,
                        label: `${labelName}/${getSystemFieldNameInDrillDown(fieldId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(fieldId),
                        itemLabel: labelName,
                        isSystemField: true,
                        order: order,
                    });
                } else if (fieldId && fieldId === Constant.DRILLDOWN_TYPE_TEXT.SUFFIX_OF_ATTACHMENTS) {
                    let attachmentsSelected = field[fieldId];
                    dataDrilldownSelected.push({
                        id: fieldId,
                        itemId: attachmentsSelected,
                        label: `${attachmentsSelected}/${getSystemFieldNameInDrillDown(fieldId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(fieldId),
                        itemLabel: attachmentsSelected,
                        isSystemField: true,
                        order: 6,
                    });
                }
            })
        );
    }

    if (!Utils.isEmptyArray(privateBookmark) || !Utils.isEmptyArray(sharedBookmark)) {
        let privateBookmarkOptionList = privateBookmark?.map(option => {
            let optionClone = {...option}
            optionClone.isPrivate = true;
            return optionClone
        });
        let listSelectedBookmarkOption = [...privateBookmarkOptionList, ...sharedBookmark];
        await Promise.all(
            listSelectedBookmarkOption?.map(async option => {
                let bookmarkID = option.bookmarkId;
                const bookmarkData = await getBookmarkById(bookmarkID);
                let labelName = Utils.isEmptyObject(bookmarkData)
                    ? ''
                    : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, bookmarkData.name);
                let order = option.isPrivate ? 6.8 : 6.9;
                let optionId =  option.isPrivate ? 'privateBookmark' : 'sharedBookmark';
                dataDrilldownSelected.push({
                    id: optionId,
                    itemId: bookmarkID,
                    label: `${labelName}/${getSystemFieldNameInDrillDown(optionId)}`,
                    fieldLabel: getSystemFieldNameInDrillDown(optionId),
                    itemLabel: labelName,
                    isBookmark: true,
                    order: order,
                });
            })
        );
    }

    if (!Utils.isEmptyArray(tagFieldList)) {
        await Promise.all(
            tagFieldList.map(async (fieldTag) => {
                let fieldtagId = !Utils.isEmptyArray(Object.keys(fieldTag)) ? Object.keys(fieldTag)[0] : '';
                if (fieldtagId && fieldTag[fieldtagId]) {
                    let fieldTagData = authen ? await getFormById(API, fieldtagId) : await getFormByIdWithoutAuthen(API, fieldtagId);

                    let tagItem = fieldTag[fieldtagId];
                    let tagItemData = {};
                    let prefixFieldTagItem = Utils.getPrefixOfId(tagItem);
                    let isFormFieldItem = ['tag', 'field', 'form'].includes(prefixFieldTagItem);
                    if (isFormFieldItem) {
                        tagItemData = authen ? await getFormById(API, tagItem) : await getFormByIdWithoutAuthen(API, tagItem);
                    } else {
                        // master field get ticket title 
                        tagItemData = await getTicketById(API, tagItem, null, authen); 
                        if (!tagItemData || Utils.isEmptyObject(tagItemData) || (tagItemData && tagItemData.id === null)) {
                            tagItemData.name = 'undefined name!';
                        } else {
                            if (tagItemData?.settingTitle && tagItemData?.settingTitle.length) {
                                tagItemData.name = Utils.getTitle(tagItemData?.settingTitle);
                            }
                        }
                    }
                    
                    if (!Utils.isEmptyObject(fieldTagData) && !Utils.isEmptyObject(tagItemData)) {
                        let tagItemName = Utils.convertJSONDataToObject(tagItemData.name)
                        let fieldLabel = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldTagData.name)
                        let isPdfSystemFile = false
                        if(fieldTagData.definition === Constant.FORM_DEFINITION.SYSTEM){
                            if(fieldLabel == '章' || fieldLabel == '節' || fieldLabel == '項'|| fieldLabel == '目' ){
                                isPdfSystemFile = true
                            }
                        }
                        let tagItemDataLabel = isFormFieldItem ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagItemName) : tagItemData.name;
                        dataDrilldownSelected.push({
                            id: fieldtagId,
                            itemId: tagItem,
                            label: `${tagItemDataLabel}/${tagItemDataLabel}`,
                            fieldLabel: fieldLabel,
                            itemLabel: tagItemDataLabel,
                            isTagField: true,
                            order: 7,
                            isPdfSystemFile
                        });
                    }
                }
            })
        );
    }

    if (!Utils.isEmptyArray(statusFieldList)) {
        let fieldStatus = statusFieldList[0];
        let fieldStatusId = !Utils.isEmptyArray(Object.keys(fieldStatus)) ? Object.keys(fieldStatus)[0] : '';
        if (fieldStatusId && fieldStatus[fieldStatusId]) {
            let statusItem = fieldStatus[fieldStatusId];

            let fieldStatusData = await getFormById(API, fieldStatusId);
            let statusItemData = await getFormById(API, statusItem);

            if (!Utils.isEmptyObject(fieldStatusData) && !Utils.isEmptyObject(statusItemData)) {
                let statusItemStructure = Utils.convertJSONDataToObject(statusItemData.structure);
                dataDrilldownSelected.push({
                    // id: fieldStatusId,
                    // itemId: statusItemData.id,
                    id: Constant.DUMMY_DRILLDOWN_STATUS_ID,
                    itemId: `${Constant.DUMMY_PREFIX_DRILLDOWN_STATUS_ITEM_ID}${statusItemStructure?.no}`,
                    label: `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusItemData.name)}/${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldStatusData.name)}`,
                    fieldLabel: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldStatusData.name),
                    itemLabel: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusItemData.name),
                    isStatusField: true,
                    order: 8,
                });
            }
        }
    }

    dataDrilldownSelected = dataDrilldownSelected.sort((a, b) => {
        return new Date(a.order) - new Date(b.order);
    });
    return dataDrilldownSelected;
}

/**
 * removeDrillDownSelected
 * @param {*} item 
 * @param {*} argsCommon 
 * @returns 
 */
export const removeDrillDownSelected = (item, argsCommon, setIsShowEditTagField) => {
    if (!item.id) {
        return;
    }
    if (item.id === 'form' && setIsShowEditTagField) {
        setIsShowEditTagField(false);
    }
    
    let currentStructure = cloneDeep(argsCommon.viewStructure);
    if (item.isSystemField) {
        let currentSystemFieldDrilldownSelected = cloneDeep(currentStructure.fields);
        let newSystemDrilldownSelected = [];
        if (item.id === 'suffixOfAttachments') {
            newSystemDrilldownSelected = currentSystemFieldDrilldownSelected.filter(field => !(field.hasOwnProperty(item.id) && field[item.id] === item.itemId));
        } else {
            newSystemDrilldownSelected = currentSystemFieldDrilldownSelected.filter(field => !field.hasOwnProperty(item.id));
        }
        
        currentStructure.fields = newSystemDrilldownSelected;
    }

    if (item.isStatusField) {
        currentStructure.statusFields = [];
    }

    if (item.isTagField) {
        let currentTagFieldDrillDownSelected = cloneDeep(currentStructure.tagFields);
        let newTagFieldDrillDownSelected = currentTagFieldDrillDownSelected.filter(field => !(field.hasOwnProperty(item.id) && field[item.id] === item.itemId));
        currentStructure.tagFields = newTagFieldDrillDownSelected;
    }

    if (
        item.id === Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID &&
        argsCommon.setDestinationPrjId
    ) {
        argsCommon.setDestinationPrjId('');
        currentStructure.ticketCreatedProjectId = '';
    }

    if(item.isBookmark){
        let currentBookmarkDrillDownSelected = cloneDeep(currentStructure[item.id]);
        let newBookmarkDrillDownSelected = currentBookmarkDrillDownSelected.filter(option => option?.bookmarkId !== item?.itemId);
        currentStructure[item.id] = newBookmarkDrillDownSelected;
    }

    if (argsCommon.setViewStructure) {
        argsCommon.setViewStructure(currentStructure);
    }
    if(argsCommon.setViewStructure && argsCommon.setRemovedTagItem) {
        argsCommon.setLastUserAction(LogKibanaConstant.SEARCH_ACTION.TAG_REMOVE)
        argsCommon.setRemovedTagItem({
            tagName: item.itemLabel,
            fieldName: item.fieldLabel
        })
    }
    
    return currentStructure;
}

/**
 * getProjectNameDrillDownDataSelected
 * @param {*} API 
 * @param {*} projectId 
 */
export const getProjectNameDrillDownDataSelected = async (API, projectId) => {
    let currentCorporationId = localStorageUtil.getAffiliationOrganization();
    let name = '';

    let projectData = await getProjectById(API, projectId);
    if (!Utils.isEmptyObject(projectData)) {
        let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectData.name);
        if (projectData.affiliationOrganization === currentCorporationId) {
            name = projectName;
        } else {
            let corporationData = await getCorporationById(API, projectData.affiliationOrganization);
            let corporationName = '';
            if (!Utils.isEmptyObject(corporationData)) {
                corporationName = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, corporationData);
            }
            // name = `${corporationName} → ${projectName}`;
            name = `${projectName} (${corporationName})`;
        }
    }

    return name;
}


/**
 * getUserNameDrillDownDataSelected
 * @param {*} API 
 * @param {*} userId 
 * @returns 
 */
export const getUserNameDrillDownDataSelected = async (API, userId) => {
    let currentCorporationId = localStorageUtil.getAffiliationOrganization();
    let name = '';

    let userData = await getUserById(API, userId);
    if (!Utils.isEmptyObject(userData)) {
        let userName = Utils.getUserNameWithActiveStatus(userData);
        name = userName;
        if (userData.affiliationOrganization !== currentCorporationId) {
            let corporationData = await getCorporationById(API, userData.affiliationOrganization);
            if (!Utils.isEmptyObject(corporationData)) {
                let corporationNameSuffixText = Utils.getCorporationNameSuffixText(corporationData);
                if (corporationNameSuffixText) {
                    name = `${userName} (${corporationNameSuffixText})`;
                }
            }
        }
    }

    return name;
}

export const onConfirmChangeForm = async (projectTargetSelected, argsAll) => {
    argsAll.setIsErrorSelected(false);
    if (projectTargetSelected === argsAll.selectedForm) {
        return;
    }

    let infoTabCsv = argsAll.panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    
    if(!Utils.isEmptyObject(infoTabCsv) && !argsAll.isLastActive) {
        if (!Utils.isEmptyObject(argsAll.mapping) && infoTabCsv?.tabList[0]?.id === argsAll.tabId) {
            for (const [key, value] of Object.entries(argsAll.mapping)) {
                if (value !== Constant.UPLOAD_CSV_KNOWLEDGE.DEFAULT_SELECTED_MAPPING) {
                    return argsAll.setIsShowPopUpConfirmChangeForm({
                        status: true,
                        projectTargetSelected: projectTargetSelected
                    });
                }
            }
        }
    }
    argsAll?.clearErrors();

    await onChangeFormCsv(argsAll, projectTargetSelected);
}

export const handleOnchangeForm = async (e, argsAll) => {
    if(argsAll.isDraftMode) {
        argsAll.setIsChangeFormDraftMode(true);
    }
    if(argsAll.isEdited) {
        return argsAll.setIsOpenDialogSelectForm({isOpen: true, value: e.target.value});
    }
    await onConfirmChangeForm(e.target.value, argsAll)
};

export const checkIsDisableBtnSentKnowledgeTicket = (argsAll, aiAutoSelectedData) => {
    // check selected create ticket type and select form
    if (
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData) ||
        !Utils.isEmptyObject(argsAll.errorCreateKnowledgeTicket)
    ) {
        return true;
    }

    // check setting view/edit permission
    if (
        Utils.isEmptyArray(argsAll.viewPermissions) ||
        Utils.isEmptyArray(argsAll.editPermissions) ||
        Utils.isEmptyString(argsAll.chatPermission)
    ) {
        return true;
    }

    // check input all fields required
    let inputUploadListField = Utils.isEmptyArray(argsAll.fileUploadList) ? argsAll.detailTicket?.attachment : argsAll.fileUploadList;
    if (argsAll.isDuplicate && argsAll.isDraft) {
        inputUploadListField = !Utils.isEmptyArray(argsAll.fileUploadList) ? argsAll.fileUploadList : [];
        argsAll.fileUpdatedList = [];
    }
    return !isInputAllFieldRequired(argsAll.fieldListData, argsAll.getValuesCreateKnowledgeTicket, inputUploadListField, argsAll?.fileUpdatedList, aiAutoSelectedData);
}

export const checkIsDisableBtnDraftKnowledgeTicket = (argsAll) => {
    if (
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData)
    ) {
        return true;
    }
    if (argsAll.isChangeFormDraftMode && argsAll.isDraftMode) {
        return false;
    }
    
    // Ticket draft not edit
    if (argsAll.isDraftMode && !argsAll.isEdited) {
        return true;
    }

    return false;
}

export const onSubmitSaveDraftKnowledgeTicket = async (
    tabId,
    panelType,
    formData,
    userDetail,
    corporationDetail,
    panelId,
    argsAll,
    fieldListData,
    aiAutoSelectedData
) => {
    argsAll.setIsLoading(true);

    let requestBody = {};

    let viewPermissions = argsAll.viewPermissions;
    let editPermissions = argsAll.editPermissions;
    let additionalViewPermissions = argsAll.additionalViewPermissions;
    let additionalEditPermissions = argsAll.additionalEditPermissions;
    let chatPermission = argsAll.chatPermission;

    let viewPermissionsSave = viewPermissions.map(p => p.value);
    let editPermissionsSave = editPermissions.map(p => p.value);
    let additionalViewPermissionsSave = getAdditionalPermissionsForSave(additionalViewPermissions);
    let additionalEditPermissionsSave = getAdditionalPermissionsForSave(additionalEditPermissions);

    let ticketType = Constant.TICKET_TYPE.KNOWLEDGE;
    let formListClone = cloneDeep(argsAll.formList);
    let formSelectedId = argsAll.selectedForm;
    let formIndex = Utils.findIndexInArrayById(formSelectedId, formListClone);
    let formTicketType = Constant.FORM_TYPE.KNOWLEDGE;
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        if (formDetail?.type) {
            formTicketType = formDetail?.type;
        }
        if(formTicketType === Constant.FORM_TYPE.FORM_MASTER) {
            ticketType = Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        }
    }

    if(Utils.isEmptyArray(viewPermissions) || Utils.isEmptyArray(editPermissions) || Utils.isEmptyString(chatPermission)) {
        return;
    }

    argsAll.setIsLoading(true);

    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === "WORKFLOW");
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData, aiAutoSelectedData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields)) {
        argsAll.setIsLoading(false);
        return;
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
    );

    let fileUploadedDeleted = [];
    if(!Utils.isEmptyArray(argsAll.fileUpdatedList)) {
        fileUploadedDeleted = argsAll.fileUpdatedList.filter(file => file.isDelete === true);
        if(!Utils.isEmptyArray(fileUploadedDeleted)) {
            fileUploadedDeleted = fileUploadedDeleted.map(file => {
                let fileClone = {...file};
                delete fileClone.isDelete;
                delete fileClone.createdAt;
                delete fileClone?.thumbnailInfo;
                return fileClone
            })
        }
    }

    let newFileUpdatedList = cloneDeep(argsAll.fileUpdatedList);
    if(!Utils.isEmptyArray(newFileUpdatedList)) {
        newFileUpdatedList = newFileUpdatedList.map(file => {
            let fileClone = {...file};
            delete fileClone?.isPrivate;
            return fileClone
        })
    }

    if (Utils.isEmptyArray(uploadFileS3Result.fileListSuccess) && Utils.isEmptyObject(uploadFileS3Result.suffixOfAttachments)) {
        let {suffixOfAttachments, listFileUploadSuccess} = createDataListFileDuplicate(newFileUpdatedList);
        uploadFileS3Result.suffixOfAttachments = suffixOfAttachments;
        newFileUpdatedList = listFileUploadSuccess;
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft && !argsAll?.isDuplicate ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(newFileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id && !argsAll?.isDuplicate ? argsAll?.detailTicket?.id : '',
        fileUploadedDeleted: fileUploadedDeleted
    };

    requestBody = {
        createTicketRequestDto: {
            outline: formData.outline,
            corporationOrigin: corporationDetail.id,
            description: formData.description,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail?.id,
            projectTarget: argsAll.projectInuseDetail?.id,
            corporationTarget: corporationDetail.id,
            ticketType: ticketType,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: argsAll.projectInuseDetail?.id,
            status: status,
            fields: fields,
            type: argsAll.selectedForm,
            customer: Constant.NA,
            viewPermission: viewPermissionsSave,
            additionalViewPermission: JSON.stringify(additionalViewPermissionsSave),
            editPermission: editPermissionsSave,
            additionalEditPermission: JSON.stringify(additionalEditPermissionsSave),
            chatPermission: chatPermission,
            public: Constant.TICKET_PUBLIC.DRAFT,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            isServicesPDFOfCorpOn: isDisplaySplitPDF(argsAll.corporationDetail, formTicketType),
            ...draftTicketInfo
        }
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    argsAll.setIsDraftMode(true);
    argsAll.setIsEdited(false);
    
    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE,
        formId: argsAll?.selectedForm,
        projectTargetId: argsAll?.projectInuseDetail?.id,
        corpTargetId: corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    // let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    // let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    // let dataLog = {
    //     rootCorporationDetail: argsAll.corporationDetail,
    //     rootProjectDetail: argsAll.projectInuseDetail,
    //     corporationDetail: argsAll.corporationDetail,
    //     projectDetail: argsAll.projectInuseDetail,
    //     userDetail: argsAll.userDetail,
    //     ticketDetail: {
    //         id: newTicket.id,
    //         outline: newTicket.outline,
    //         creator: newTicket.creator,
    //         usingFormName: usingFormName,
    //         createdAt: newTicket.createdAt,
    //     },
    //     metaData: {
    //         formDetailId: argsAll.selectedForm,
    //         additionalViewPermissions: argsAll.additionalViewPermissions,
    //         viewPermissions: viewPermissionsSave,
    //         ticketType,
    //     },
    //     isCreateKnowledge: true,
    //     isCreateCSV: false,
    //     ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    // }

    // let logKibanaData = createKibanaDataContentOperation(
    //     lastUserAction,
    //     dataLog
    // );
    // let param = {
    //     logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
    //     logKibanaData: logKibanaData
    // };
    // createKibanaLogAPI(argsAll.API, param);
    // argsAll.setLastUserAction(null);
    // const attachmentList = fieldListData.find(field => field.sysField === 'attachments');
    // await handleUploadFilesForTicketKnowledge(
    //     argsAll.API,
    //     formData,
    //     newTicket,
    //     argsAll.setIsModalUploadFileError,
    //     argsAll.setFileUploading,
    //     ticketType,
    //     null,
    //     null,
    //     attachmentList
    // );

    //update usingTicket of formList 
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        let usingTickets = Utils.convertJSONDataToObject(formDetail.usingTickets);

        if (!Utils.isEmptyObject(usingTickets)) {
            if (usingTickets[newTicket.affiliationProject]) {
                usingTickets[newTicket.affiliationProject].push(newTicket.id);
            } else {
                usingTickets[newTicket.affiliationProject] = [newTicket.id];
            }
        } else {
            usingTickets = {};
            usingTickets[newTicket.affiliationProject] = [newTicket.id];
        }

        formListClone[formIndex].usingTickets = JSON.stringify(usingTickets);
    }
    argsAll.setFormList(formListClone);

    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        isDraft: true,
        API: argsAll.API
    });

    argsAll.enqueueSnackbar(I18n.get('MSG-CM-SAVE-DRAFT-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return;
};

export const initDataTicketKnowledgeDraft = async argsAll => {
    if (!argsAll.detailTicket || Utils.isEmptyObject(argsAll.detailTicket)) return;

    // set setting permissions value
    let dataSettingDefault = {
        viewPermission: argsAll.detailTicket?.viewPermission
            ? argsAll.detailTicket?.viewPermission
            : [],
        editPermission: argsAll.detailTicket?.editPermission
            ? argsAll.detailTicket?.editPermission
            : [],
        additionalViewPermission: argsAll.detailTicket?.additionalViewPermission
            ? argsAll.detailTicket?.additionalViewPermission
            : '',
        additionalEditPermission: argsAll.detailTicket?.additionalEditPermission
            ? argsAll.detailTicket?.additionalEditPermission
            : '',
        chatPermission: argsAll.detailTicket?.chatPermission
    };

    if (!argsAll.isDuplicate) {
        argsAll.setDataSettingDefaults(dataSettingDefault);
    }

    // set form data
    if (argsAll.draftData?.formDetail && argsAll.draftData?.fieldListData) {
        let fieldListData = Utils.convertJSONDataToObject(argsAll.draftData.fieldListData);
        // Form detail
        let formDetail = Utils.convertJSONDataToObject(argsAll.draftData?.formDetail);
        submitOnchangeForm(formDetail.id, argsAll, formDetail, false, fieldListData);

        // Form data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        let objFormData =
            cloneCurrentPanelInitData?.formData &&
            !Utils.isEmptyObject(cloneCurrentPanelInitData?.formData)
                ? cloneCurrentPanelInitData?.formData
                : {};
        if (!Utils.isEmptyArray(fieldListData)) {
            fieldListData.forEach(field => {
                if (!TmpHiddenSysFieldInTicketDetail.includes(field.sysField)) {
                    if (field.type === Constant.FORM_TYPE.FIELD_TAG) {
                        let defaultSelectedTag = [];
                        if (!Utils.isEmpty(field?.defaultValue)) {
                            defaultSelectedTag = field.defaultValue;
                        }
                        objFormData[field.id] = defaultSelectedTag;
                    } else {
                        objFormData[field.id] = field.value;
                    }
                }
            });
            cloneCurrentPanelInitData.formData = objFormData;
            argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        }
        argsAll.setTriggerSaveFormData(Date.now().toString());
    }
};

export const submitOnchangeForm = async (
    selectedFormId,
    argsAll,
    formDetail,
    isKeepLoading = false,
    initFieldListData
) => {
    // Reset old value of form, set new form id
    argsAll.setIsLoading(true);
    // User click change form, not init data
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        argsAll.resetValuesCreateKnowledgeTicket();
        unregisterField(
            argsAll.fieldListData,
            argsAll.unregisterCreateKnowledgeTicket,
            argsAll.resetValuesCreateKnowledgeTicket
        );

        // Reset attact file
        argsAll.setValueCreateKnowledgeTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
        argsAll.setFileUploadList([]);

        // Reset current panel init data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        delete cloneCurrentPanelInitData.formData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        argsAll.setTriggerSaveFormData(Date.now().toString());
        argsAll.setIsEdited(true);
    }
    argsAll.setSelectedForm(selectedFormId);

    let infoTabCsv = argsAll.panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    
    if(Utils.isEmptyObject(infoTabCsv)) {
        argsAll.setSelectedFormCsv(selectedFormId);
    }

    if(!Utils.isEmptyObject(infoTabCsv)) {
        if(infoTabCsv?.tabList[0].id === argsAll.tabId) {
            argsAll.setSelectedFormCsv(selectedFormId);
        }
    }
    argsAll.setValueCreateKnowledgeTicket('selectedForm', selectedFormId);
    argsAll.setValueCreateKnowledgeTicket('fileUploadList', []);

    let selectedFormDetail = formDetail;
    if (!selectedFormDetail || Utils.isEmptyObject(selectedFormDetail)) {
        selectedFormDetail = await getFormFromFormListById(selectedFormId);
    }

    const formStructure = Utils.convertJSONDataToObject(selectedFormDetail?.structure);
    let fieldOrderInForm = {};
    if (!Utils.isEmptyObject(formStructure)) {
        for (const [structureKey, structureValue] of Object.entries(formStructure)) {
            if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
            }
        }
    }

    if (!Utils.isEmptyObject(selectedFormDetail)) {
        // validate display AI Auto Log
        const isAIAutoForm = Utils.isSystemAIAutoForm(selectedFormDetail);
        const isUsingAIAuto = Utils.isCorporationOnAIAuto(argsAll?.corporationDetail);
        argsAll?.setIsShowAiAutoLog(isAIAutoForm && isUsingAIAuto)
        
        argsAll.setSelectedFormInfo(selectedFormDetail);
        let getFieldListResult = [];
        if (!Utils.isEmptyArray(initFieldListData)) {
            getFieldListResult = cloneDeep(initFieldListData);
        } else {
            
            const customFieldList = await getListCustomFiledOfForm(
                formStructure,
                argsAll.API,
                selectedFormDetail.affiliationOrganization
            );
            getFieldListResult = getFormFieldData(formStructure, customFieldList);
        }

        if (
            [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(
                selectedFormDetail.type
            )
        ) {
            getFieldListResult = Array.from(getFieldListResult, field => {
                field.structure.publicForCustomer = 3;
                return field;
            });
        }

        getFieldListResult = getFieldListResult.filter(
            x =>
                Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );

        // filter field not share for corporation of form
        if (selectedFormDetail.definition !== Constant.FORM_DEFINITION.SYSTEM) {
            getFieldListResult = getFieldListResult.filter(x => {
                // sys field auto pass
                if (
                    (x.definition = Constant.FORM_DEFINITION.SYSTEM) ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                ) {
                    return true;
                }

                // get corporation of form
                let currentCorporationDetailId = argsAll.corporationDetail?.id;

                // field belongs to corporation
                if (x.affiliationOrganization === currentCorporationDetailId) {
                    return true;
                }

                // field is shared
                if (currentCorporationDetailId) {
                    let shareRangeOfField = Utils.convertJSONDataToObject(x.shareRange)
                        ? []
                        : Utils.convertJSONDataToObject(x.shareRange);
                    return shareRangeOfField?.includes(currentCorporationDetailId);
                }
                return true;
            });
            // filter field inactive
            getFieldListResult = getFieldListResult.filter(field => {
                let usingProjectOfField = Utils.convertJSONDataToObject(field.usingProjects);
                return usingProjectOfField?.includes(selectedFormDetail.affiliationProject);
            });
        }

        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }

            if (['guestOrg', 'guestProject'].includes(field.sysField)) {
                field.structure.required = true;
            }
            return field;
        });

        getFieldListResult = getFieldListResult
            .filter(field => {
                if (
                    Utils.isSystemFormChatAIPrompt(selectedFormDetail) ||
                    Utils.isSystemAIAutoForm(selectedFormDetail) ||
                    Utils.isSystemSDAutoForm(selectedFormDetail)
                )
                    return true;
                if (
                    (!field.sysField ||
                        !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)) &&
                    field?.usingProjects?.includes(selectedFormDetail?.affiliationProject)
                )
                    return true;
                return false;
            })
            .sort((a, b) => {
                if (!a.order || !b.order) return 1;
                // attachment always at bottom
                if (a.sysField === 'attachments') return 1;
                if (b.sysField === 'attachments') return -1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });
        if (argsAll.isDuplicate && argsAll.projectInuseDetail.id !== formDetail.affiliationProject) {
            getFieldListResult = getFieldListResult
                .filter(
                    field => field.publicForCustomer !== Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW
                )
        }

        if (!Utils.isEmptyArray(initFieldListData)) {
            let newListField = [];
            getFieldListResult.forEach(fieldData => {
                let defaultValue;
                if (
                    fieldData.type === Constant.FORM_TYPE.FIELD_TAG ||
                    fieldData.structure?.UI === Constant.FIELD_UI.DROP_FILE
                ) {
                    defaultValue = [];
                } else {
                    defaultValue = '';
                }

                if (fieldData.defaultValue) {
                    defaultValue = fieldData.defaultValue;
                } else if (fieldData.value) {
                    defaultValue = fieldData.value;
                }

                let fieldDataTmp = {
                    ...fieldData,
                    defaultValue
                };
                if (argsAll.isDraftMode) {
                    fieldDataTmp.structure.publicForCustomer =
                        Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
                }
                newListField.push(fieldDataTmp);
            });

            argsAll.setFiledListData([...newListField]);
        } else {
            argsAll.setFiledListData([...getFieldListResult]);
        }
    }

    if (!isKeepLoading) {
        argsAll.setIsLoading(false);
    }
};

/**
 * 
 * @param {*} event 
 * @param {*} reason 
 * @param {*} argsAll 
 * @returns 
 */
 export const closeCallbackDeleteDraftKnowledgeButton = (event, reason, argsAll) => {
    if (event && reason === 'backdropClick') {
        return false;
    }
    argsAll.setIsOpenDialogConfirmDeleteDraftKnowledge(false);
}

/**
 * 
 * @param {*} argsAll 
 */
export const acceptSoftDeleteDraftKnowledgeButton = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsOpenDialogConfirmDeleteDraftKnowledge(false);
    submitSoftDeleteDraft(API, detailTicket, currentUserDetail, argsAll);
}

export const acceptRestoreKnowledgeTicketDraft = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsShowDialogRestoreTicket(false);
    submitSoftDeleteDraft(API, detailTicket, currentUserDetail, argsAll, null);
}

export const submitSoftDeleteKnowledgeTicket = async (API, detailTicket, deletedAt, currentUserDetail, argsAll) => {
    let submitSoftDeleteTicketRequestDto = {
        ticketId: detailTicket.id,
        currentUserId: currentUserDetail.id,
        currentUserMail: currentUserDetail.mail,
        corporationId: currentUserDetail.affiliationOrganization,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_DELETED_AT,
        ticketType: detailTicket.ticketType,
        deletedAt: deletedAt
    };
    
    return await editTicketData(API, submitSoftDeleteTicketRequestDto);
};

/**
 * 
 * @param {*} args 
 * @returns 
 */
const getPanelType = (args) => {
    let {panelList} = args
    let currentPanelIndex = Utils.findIndexInArrayById(args.panelId, panelList);
    if (currentPanelIndex === -1) return '';
    let currentPanel = panelList[currentPanelIndex];
    return currentPanel.type;
};

/**
 * 
 * @param {*} args 
 * @returns 
 */
const getTicketListType = (args) => {
    return getPanelType(args) === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
        ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
        : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST;
};

/**
 * 
 * @param {*} API 
 * @param {*} detailTicket 
 * @param {*} currentUserDetail 
 * @param {*} argsAll 
 */
 export const submitSoftDeleteDraft = (API, detailTicket, currentUserDetail, argsAll, deletedAt = new Date().toISOString()) => {
    argsAll.setIsLoading(true);

    submitSoftDeleteKnowledgeTicket(API, detailTicket, deletedAt, currentUserDetail, argsAll)
        .then(result => {

            argsAll.setIsLoading(false);
            argsAll.reloadTicketListByPanelType({
                panelType: getTicketListType(argsAll)
                    ? getTicketListType(argsAll)
                    : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            });
            let msgNoti = deletedAt ? I18n.get('MSG-CM-DELETE-CONTENT-SUCCESSFULLY') : I18n.get('MSG-CM-RESTORE-CONTENT-SUCCESSFULLY');
            argsAll.enqueueSnackbar(msgNoti, {
                variant: 'success',
                autoHideDuration: 3000
            });
            argsAll.reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                id: detailTicket.id
            })

            if (deletedAt) {
                reloadPanelAfterSoftDeleteTicketKnowledge(
                    {...argsAll, setPanelList: argsAll.setPanelListRecoilState},
                    detailTicket.id,
                    result.updatedChildrenTicketIdList,
                    true,
                    deletedAt
                );
            } else {
                //  updatePanelAfterBackToDraft
                argsAll.updatePanelAfterCreateTicket({
                    panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                    componentName: Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT,
                    tabId: detailTicket.id,
                    isDraft: true,
                    panelId: argsAll.panelId,
                    ticketId: detailTicket.id,
                    ticketOutline: detailTicket.outline,
                    API: API,
                    updatedChildrenTicketIdList: result?.updatedChildrenTicketIdList,
                    isTicketDeleted: false
                })
            }
        })
        .catch(err => {
            argsAll.setIsLoading(false);
            argsAll.reloadTicketListByPanelType({
                panelType: getTicketListType(argsAll)
                    ? getTicketListType(argsAll)
                    : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            });

            argsAll.enqueueSnackbar(I18n.get('SYSMSG001'), {
                variant: 'error',
                autoHideDuration: 3000
            });
        })
};

const handleUploadFilesForTicketKnowledge = async (
    API,
    formData,
    newTicket,
    setIsModalUploadFileError,
    setFileUploading,
    ticketType,
    fileUploadListState,
    fileUploaded,
    attachmentList
) => {
    formData = cloneDeep(formData);
    let fileUploadList = [];
    if (formData.fileUploadList && !Utils.isEmptyArray(formData?.fileUploadList)) {
        fileUploadList = formData?.fileUploadList;
    } else if (fileUploadListState && !Utils.isEmptyArray(fileUploadListState)) {
        fileUploadList = fileUploadListState;
        formData.fileUploadList = fileUploadListState;
    }

    let resUpload = {
        fileListSuccess: attachmentList?.value?.length > 0 ? attachmentList.value : [],
        suffixOfAttachments: {}

    }
    if (formData?.fileUploadList?.length > 0) {
        resUpload = await uploadTicketFileToS3(
            formData,
            newTicket,
            setFileUploading,
            fileUploaded
        );
    }
    let usage = Constant.TICKET_USAGE.REQ;
    switch (ticketType) {
        case Constant.TICKET_TYPE.KNOWLEDGE:
        case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
            usage = Constant.TICKET_USAGE.KNOWLEDGE;
            break;
        case Constant.TICKET_TYPE.TASK:
            usage = Constant.TICKET_USAGE.TASK;
            break;
        default:
            break;
    }
        const attachmentInputData = {
            ticketId: newTicket.id,
            dataType: Constant.TICKET_DATA_TYPE.FIELD,
            dataID: Constant.TICKET_DATA_ID.ATTACHMENT,
            dataValue: JSON.stringify({
                value: resUpload.fileListSuccess
            }),
            usage: usage,
            affiliationOrganization: newTicket.affiliationOrganization,
            affiliationProject: newTicket.affiliationProject,
            customer: newTicket.customer,
            creator: newTicket.creator,
            dataLang: 'NA',
            readPermission: newTicket.readPermission,
            liveOrArchived: newTicket.liveOrArchived

        }
        const suffixOfAttachmentsInputData = {
            ticketId: newTicket.id,
            dataType: Constant.TICKET_DATA_TYPE.FIELD,
            dataID: Constant.TICKET_DATA_ID.SUFFIX_OF_ATTACHMENTS,
            dataValue: JSON.stringify({
                value: resUpload?.suffixOfAttachments
            }),
            affiliationOrganization: newTicket.affiliationOrganization,
            affiliationProject: newTicket.affiliationProject,
            customer: newTicket.customer,
            creator: newTicket.creator,
            dataLang: 'NA',
            readPermission: newTicket.readPermission,
            liveOrArchived: newTicket.liveOrArchived,
            usage: usage
        }
        let promiseList = [createTicketRecord(API,attachmentInputData),createTicketRecord(API,suffixOfAttachmentsInputData)];
        await Promise.all(promiseList);
    return true;
};

export const handlerShowButtonEditTicket = (value, allArgs, formData) => {
    let cloneFieldListDefaultData = cloneDeep(allArgs.fieldListDefaultData);
    // filter field is required
    let realRequiredFieldList = cloneFieldListDefaultData.filter(
        field =>
            field.sysField !== Constant.TICKET_DATA_ID.TICKET_ID &&
            !Utils.isEmptyObject(field) &&
            field?.structure?.required
    );

     //filter field is and or and exclude of ai auto event form
     const specialFieldsOfAiAutoEvent = cloneFieldListDefaultData.filter(field =>
        [
            Constant.AI_AUTO.SYSTEM_FIELD.AND,
            Constant.AI_AUTO.SYSTEM_FIELD.OR,
            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
        ].includes(field.sysField)
    );

    realRequiredFieldList = realRequiredFieldList.filter(field => {
        return !(!isShowFieldEventTypeChatThread(allArgs?.aiAutoSelectedData) && field?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER);
    })

    if (realRequiredFieldList.length < 0) {
        allArgs.setIsEditTicket(true);
        return;
    }

    //get all fields edit
    let fields = Utils.getEditTicketData(formData, allArgs.fieldListDefaultData, allArgs.aiAutoSelectedData);
    let valueTags = value;
    let result = false;
    let newFieldList = [];

    // Validate for event form
    if (allArgs?.formDetail?.definition === Constant.FORM_DEFINITION.SYSTEM && allArgs?.formDetail?.definitionVariant === Constant.FORM_VARIANT.AI_AUTO.EVENT) {
        let isInputAllRequiredValue = true;
        for (const fieldDetail of realRequiredFieldList) {
            for (const property in fields) {
                if (fieldDetail.id === property && fieldDetail?.type === Constant.FORM_TYPE.FIELD_TAG) {
                    let realValue = fields[property];
                    if (!realValue || Utils.isEmptyArray(realValue)) {
                        isInputAllRequiredValue = false;
                        break;
                    }
                }
            }
        }
        return allArgs.setIsEditTicket(isInputAllRequiredValue)
    }


    // Assign edit value to each required field
    for (let i = 0; i < realRequiredFieldList.length; i++) {
        let element = realRequiredFieldList[i];
        for (const property in fields) {
            if (element.id === property) {
                element.realValue = fields[property];
                newFieldList.push(element);
            }
        }
    }

    // Check if each required field has enough data
    let arrayResult = [];
    for (let index = 0; index < newFieldList.length; index++) {
        let element = newFieldList[index];
        if (
            [
                Constant.FIELD_UI.TEXT,
                Constant.FIELD_UI.NUMBER,
                Constant.FIELD_UI.TEXT_AREA,
                Constant.FIELD_UI.DATE,
                Constant.FIELD_UI.IFRAME,
                Constant.FIELD_UI.URL
            ].includes(element.structure.UI)
        ) {
            if (element?.realValue.toString().trim() !== '') {
                arrayResult.push(true);
                continue;
            }
            arrayResult.push(false);
            break;
        }

        if (Constant.FIELD_UI.FIELD_RICHTEXT === element.structure.UI) {
            const richTextValue = getRichTextFieldContent(element?.realValue)
            let isInputFieldRequired = true;
            if (!richTextValue || richTextValue === '""') {
                isInputFieldRequired = false;
            }
            arrayResult.push(isInputFieldRequired);
        }

        if (Constant.FIELD_UI.TAG === element.structure.UI) {
            const isHasValue = !Utils.isEmptyArray(element?.realValue);
            arrayResult.push(isHasValue)
        }
    }

    if (newFieldList.find(item => item.structure.UI === Constant.FIELD_UI.DROP_FILE)) {
        if (allArgs?.fileUpdatedList?.length > 0 || allArgs?.fileUploadList?.length > 0) {
            arrayResult.push(true);
        } else {
            arrayResult.push(false);
        }
    }

    /**this comment for note 18/12/2024 */
    if (newFieldList.find(item => item.structure.UI === Constant.FIELD_UI.TAG)) {
        if (!allArgs.isTagList) {
            arrayResult.push(true);
        } else if (allArgs.tagListValue.length > 0 && !valueTags) {
            arrayResult.push(true);
        } else if (valueTags && valueTags.length > 0) { // Don't need check to remove default empty item with value = null. Because we will clear it in before steps. ex: MenuTagInPutBase:327
            arrayResult.push(true);
        } else {
            arrayResult.push(false);
        }
    }
    const specialFieldOfAiAutoEventIds = _.map(specialFieldsOfAiAutoEvent, i=> i?.id)
    if(!Utils.isEmptyArray(specialFieldOfAiAutoEventIds)){
        const valuesOfSpecialAiAutoFields = _.map(specialFieldOfAiAutoEventIds, i=>{
            return formData[i] || []
        }).flat()
        const errorValues = _.filter(valuesOfSpecialAiAutoFields, i=> i?.isShow === false)
        if(errorValues.length > 0){
            arrayResult.push(false)
        }
    }
    // Check data and set button display save
    if (!arrayResult.includes(false)) {
        result = true;
    }
    allArgs.setIsEditTicket(result);
}

export const onChangeFormCsv = async (argsAll, projectTargetSelected) => {
    argsAll.setIsEdited(false);
    argsAll.setIsShowPopUpConfirmChangeForm({status: false});
    argsAll.setIsSelectedEditPermissions(false);
    argsAll.setIsSelectedViewPermissions(false);

    argsAll.setFileUploadList([]);
    // argsAll.setSelectedPublicRange(Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME);
    argsAll.setIsOpenDialogSelectForm({isOpen: false, value: ''})
    argsAll.setIsLoading(true);
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        unregisterField(argsAll.fieldListData, argsAll.unregisterCreateKnowledgeTicket);

        // Reset current panel init data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        delete cloneCurrentPanelInitData.formData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
    }
    argsAll.setSelectedForm(projectTargetSelected);

    let infoTabCsv = argsAll.panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    
    if(Utils.isEmptyObject(infoTabCsv)) {
        argsAll.setSelectedFormCsv(projectTargetSelected);
    }

    if(!Utils.isEmptyObject(infoTabCsv)) {
        if(infoTabCsv?.tabList[0].id === argsAll.tabId) {
            argsAll.setSelectedFormCsv(projectTargetSelected);
        }
    }


    argsAll.setValueCreateKnowledgeTicket('selectedForm', projectTargetSelected);
    let selectedFormDetail = await getFormFromFormListById(projectTargetSelected);
    if (!Utils.isEmptyObject(selectedFormDetail)) {
        if (
            isDisplayOptionSearchSynonym(argsAll.corporationDetail, argsAll.projectInuseDetail) &&
            selectedFormDetail.isSynonym
        ) {
            selectedFormDetail = Utils.setDefaultPermissionForSynonymForm(selectedFormDetail)
        }
        
        argsAll.setSelectedFormDetail(selectedFormDetail);

        argsAll.setSelectedFormInfo(selectedFormDetail);
        const formStructure = JSON.parse(selectedFormDetail?.structure);
        const customFieldList = await getListCustomFiledOfForm(
            formStructure,
            argsAll.API,
            selectedFormDetail.affiliationOrganization
        );
        let getFieldListResult = getFormFieldData(formStructure, customFieldList);
        // Filter do_not_show_field
        // if (selectedFormDetail.affiliationProject !== argsAll.projectInuseDetail.id && (selectedFormDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE || selectedFormDetail.type === Constant.FORM_TYPE.FORM_MASTER)) {
        //     getFieldListResult = getFieldListResult.filter(field => {
        //         if (field?.structure?.publicForCustomer === Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW) {
        //             return false;
        //         } else {
        //             return true;
        //         }
        //     })
        // }

       getFieldListResult = Array.from(getFieldListResult,(field) => {
            field.structure.publicForCustomer = 3
            return field
        });

        // Get field order in form
        let fieldOrderInForm = {};
        if (!Utils.isEmptyObject(formStructure)) {
            for (const [structureKey, structureValue] of Object.entries(formStructure)) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }
        getFieldListResult = getFieldListResult.filter(field => {
            let isKnowledgeSystemPrompt = false
            if (
                Utils.isSystemFormChatAIPrompt(selectedFormDetail) ||
                Utils.isSystemAIAutoForm(selectedFormDetail) ||
                Utils.isSystemSDAutoForm(selectedFormDetail)
            )
                isKnowledgeSystemPrompt = true;

            if (
                (!field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)) &&
                field?.usingProjects?.includes(selectedFormDetail?.affiliationProject)
            )
                isKnowledgeSystemPrompt = true;
            return isKnowledgeSystemPrompt
        }).sort((a, b) => {
            if (!a.order || !b.order) return 1
            // attachment always at bottom
            if (a.sysField === 'attachments') return 1;
            if (b.sysField === 'attachments') return -1;

            if (!Utils.isEmptyObject(fieldOrderInForm)) {
                return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
            }
            return 1;
        });

        
        argsAll.setFiledListData([...getFieldListResult]);
        if (argsAll?.setFlagReset) {
            argsAll.setFlagReset(true);
        }
    }
    argsAll.setIsLoading(false);
}

export const disabledAllField = (panelList, tabId, handleStatus) => {
    let infoTabCsv = panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    if(Utils.isEmptyObject(infoTabCsv)) {
        return false
    };

    if(!Utils.isEmptyObject(infoTabCsv)) {
        if(infoTabCsv?.tabList[0].id !== tabId) {
            return false;
        }
    }
    if([
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START,
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS,
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
    ].includes(handleStatus)) {
        return true;
    }

    return false;
}

export const resetChatPermissionDefault = (originViewPermission, originChatPermission) => {
    if (
        (originViewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG) ||
        originViewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) && 
        ![Constant.KNOWLEDGE_CHAT_PERMISSION.NO, Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION].includes(originChatPermission)
    ) {
        return Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT
    }

    return originChatPermission
}

export const isDataInputUrlError = (fieldListData, errorList) => {
    let  fieldUrlIds = fieldListData?.filter(fieldData => fieldData.structure.UI === Constant.FIELD_UI.URL).map(field => field.id);
    let isExistUrlError = Object.keys(errorList).some(item => fieldUrlIds.includes(item));
    if (isExistUrlError) {
        return true;
    }
    return false
}

/**
 * 
 * @param {*} corporationId 
 * @param {*} projectId 
 * @param {*} fieldInfo 
 * @param {*} selectedOptionOfField 
 * @returns 
 */
export const getTagItemsByRelatedSystemFieldValue = (
    corporationId,
    projectId,
    userId,
    sysFieldOfField,
    selectedOptionOfField,
    setOptionsOfTagField,
    setIsLoading,
    isFirstRenderFromTicketDetail = false,
    formsInCorporation = [],
    fieldsInCorporation = [],
    projectsInCorporation = []
) => {
    console.log('getTagItemsByRelatedSystemFieldValue', {setOptionsOfTagField, sysFieldOfField})
    if (!setOptionsOfTagField) return false;
    let tagItems = [];
    switch (sysFieldOfField) {
        case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:{
            setIsLoading(true);
            getFormsByTicketTypeWithAnyValue(
                corporationId,
                projectId,
                selectedOptionOfField?.sysField,
                formsInCorporation
            )
                .then(result => {
                    setOptionsOfTagField(preValue => {
                        if (
                            _.differenceBy(
                                preValue[Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE],
                                result,
                                'id'
                            ).length == 0 &&
                            preValue[Constant.AI_AUTO.SYSTEM_FIELD.AND]?.length > 0 &&
                            isFirstRenderFromTicketDetail
                        ){
                            return preValue;
                        }

                        return {
                            ...preValue,
                            [Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE]: result,
                            [Constant.AI_AUTO.SYSTEM_FIELD.AND]: [],
                            [Constant.AI_AUTO.SYSTEM_FIELD.OR]: [],
                            [Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE]: []
                        };
                    });
                })
                .catch(err => {
                    console.log('error query forms', err);
                }).finally(()=>{
                    setIsLoading(false);
                })
            break;
        }
        case Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE:{
            setIsLoading(true);
            getDataForAndOrExcludeFieldByFormId(
                corporationId,
                projectId,
                userId,
                selectedOptionOfField?.value,
                formsInCorporation,
                fieldsInCorporation,
                projectsInCorporation
            )
                .then(result => {
                    setOptionsOfTagField(preValue => {
                        return {
                            ...preValue,
                            [Constant.AI_AUTO.SYSTEM_FIELD.AND]: result,
                            [Constant.AI_AUTO.SYSTEM_FIELD.OR]: result,
                            [Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE]: result
                        };
                    });
                })
                .catch(err => {
                    console.log('error items forms', err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
                break;
        }
        case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
            setOptionsOfTagField(preValue => {
                return {
                    ...preValue,
                    [Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER]: new Date().getTime() // for trigger
                };
            });
            break;
        default:
    }

    return tagItems;
};

const getFormsByTicketTypeWithAnyValue = async (corporationId, projectId, anyValue, formsInCorporation = []) => {
    let selectedTicketType;
    switch (anyValue) {
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA:
            selectedTicketType = Constant.FORM_TYPE.FORM_REQ_QA;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE:
            selectedTicketType = Constant.FORM_TYPE.FORM_REQ_NOTICE;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK:
            selectedTicketType = Constant.FORM_TYPE.FORM_TASK;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL:
            selectedTicketType = Constant.FORM_TYPE.EMAIL_FORMAT;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE:
            selectedTicketType = Constant.FORM_TYPE.FORM_KNOWLEDGE;
            break;
        default:
    }

    const forms = await getFormsByTicketTypeOfCorporationAndProjectInuse(
        corporationId,
        projectId,
        selectedTicketType,
        formsInCorporation
    );
    return forms || []
};

const getFormsByTicketTypeOfCorporationAndProjectInuse = async (
    corporationId,
    projectId,
    ticketType,
    formsInCorporation = []
) => {
    //form list atom is not existed. query form list of project.
    if (formsInCorporation?.length == 0 || !formsInCorporation) {
        formsInCorporation = await getFormListByProject(null, corporationId, projectId);
    }

    const formsOfProjectInuse = _.filter(
        formsInCorporation,
        form => form?.usingProjects?.includes(projectId) && form?.type === ticketType
    );

    if (formsOfProjectInuse?.length === 0) return [];

    let formList = sortListByOrder(formsOfProjectInuse, projectId);
    // Sort with 'system' items on top
    formList = formList.sort((a, b) => {
        if (
            a?.definition === Constant.FORM_DEFINITION.SYSTEM &&
            b?.definition === Constant.FORM_DEFINITION.USER
        ) {
            return -1; // a comes before b
        }
        if (
            a?.definition === Constant.FORM_DEFINITION.USER &&
            b?.definition === Constant.FORM_DEFINITION.SYSTEM
        ) {
            return 1; // b comes before a
        }
        return 0; // No change in order for items of the same type
    });
    return formList;
};

const getDataForAndOrExcludeFieldByFormId = async (
    corporationId,
    projectId,
    userId,
    formId,
    formsInCorporation = [],
    fieldsInCorporation = [],
    projectsInCorporation = []
) => {
    if (!corporationId || !projectId || !formId) return [];
    let formDetail = {}

    formDetail = _.find(formsInCorporation, form => form?.id === formId);
    
    if (!formDetail){
        formDetail = await getFormById(null, formId);
    }

    if (Utils.isEmptyObject(formDetail)) return [];

    const PROJECT_TYPES_DISPLAY_IN_FIELD = [Constant.PROJECT_TYPE.GENERAL];
    const FORM_TYPES_NEED_GET_WORK_FOLLOW_FIELD = [
        Constant.FORM_TYPE.FORM_REQ_QA,
        Constant.FORM_TYPE.FORM_TASK,
        Constant.FORM_TYPE.EMAIL_FORMAT
    ];
    let result = [];

    /**
     * get fields list in form. start
     */
    const formStructure = Utils.convertJSONDataToObject(formDetail?.structure);
    const fieldIdsOfForm = _.map(Object.values(formStructure), i => i?.field).filter(i => i);

    let fieldsListOfForm = _.filter(fieldsInCorporation, field =>
        fieldIdsOfForm?.includes(field?.id)
    );

    if (
        (fieldsInCorporation?.length === 0 || !fieldsInCorporation) &&
        fieldsListOfForm?.length !== fieldIdsOfForm?.length
    ) {
        fieldsListOfForm = await getFieldListInForm(
            null,
            formDetail?.affiliationOrganization,
            fieldIdsOfForm
        );
    }


    /**
     * get fields list in form. end
     */

    /**
     * get all tag items in form. start
     */
    // query fields in form
    //normal tag fields
    const tagFieldsInForm = _.filter(
        fieldsListOfForm,
        field =>
            field?.type === Constant.FORM_TYPE.FIELD_TAG &&
            field?.definition !== Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD
    );
    //master tag fields
    const masterTagFieldsInForm = _.filter(
        fieldsListOfForm,
        field =>
            field?.type === Constant.FORM_TYPE.FIELD_TAG &&
            field?.definition === Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD
    );

    // mapping field ids to query items theirs
    const tagFieldIds =  _.map(tagFieldsInForm, tagField => {
        return tagField?.id
    });

    // queries master tag items
    const userInfoToQueryMasterField = {
        userId: userId,
        projectInuse: projectId,
        organizationInuse: corporationId
    };
    const queriesMasterTagItemInForm = _.map(masterTagFieldsInForm, masterField => {
        return queryListMasterKnowledgeTicketOfForm(
            null,
            masterField?.affiliationOrganization,
            masterField?.affiliationProject,
            masterField?.relatedMasterForm,
            userInfoToQueryMasterField
        );
    });

    //query tag items.
    const tagItems = await getTagItemsByParentFieldIds(tagFieldIds)
    //query master tag items
    const masterTagItemsByClusterFields = await Promise.all(queriesMasterTagItemInForm);
    //rename tag items
    const renamedTagItems = renameTagItemToStashFormat(tagItems, tagFieldsInForm, projectId);
    //rename master tag items
    const renamedMasterTagItems = renameMasterTagItemToStashFormat(
        masterTagItemsByClusterFields,
        masterTagFieldsInForm
    );
    result = _.concat(result, renamedTagItems, renamedMasterTagItems);
    /**
     * get all tag items in form. end
     */
    switch (formDetail?.type) {
        case Constant.FORM_TYPE.FORM_REQ_QA:
        case Constant.FORM_TYPE.FORM_REQ_NOTICE: {
            // get projects in corp and b2b project customer of project inuse. filter project inuse
            if (projectsInCorporation?.length == 0 || !projectsInCorporation) {
                projectsInCorporation = await getAllProjectListInCorporation(null, corporationId);
            }
            let b2bCustomersOfProject = await Promise.all([
                getActiveB2BCustomerProjectListOfProject(
                    null,
                    projectId,
                    true,
                    Constant.ACTIVE_FLAG.ACTIVE
                ),
                getActiveB2BCustomerProjectListOfProject(
                    null,
                    projectId,
                    true,
                    Constant.ACTIVE_FLAG.INACTIVE
                )
            ]);
            b2bCustomersOfProject = _.flatten(b2bCustomersOfProject);
            const projectsInCorp = _.filter(
                [...projectsInCorporation, ...b2bCustomersOfProject],
                project => {
                    let isValidProject = true;
                    // if form qa. we will filter project inuse
                    if (formDetail?.type === Constant.FORM_TYPE.FORM_REQ_QA) {
                        isValidProject = project?.id !== projectId;
                    }

                    return (
                        isValidProject &&
                        (project?.orgActive
                            ? project?.orgActive === Constant.CORPORATION_ACTIVE.ACTIVE
                            : !!project) &&
                        project?.active === Constant.ACTIVE_FLAG.ACTIVE
                    );
                }
            ).map(flattenedProject => {
                if (
                    flattenedProject?.active === Constant.ACTIVE_FLAG.ACTIVE &&
                    _.includes(PROJECT_TYPES_DISPLAY_IN_FIELD, flattenedProject?.type)
                ) {
                    return {
                        ...flattenedProject,
                        isShow: true
                    };
                }
                return {
                    ...flattenedProject,
                    isShow: false
                };
            });
            result = _.concat(
                result,
                renameDBRecordsToStashFormatByFormType(projectsInCorp, formDetail?.type)
            );
            break;
        }
        case Constant.FORM_TYPE.FORM_TASK:
            break;
        case Constant.FORM_TYPE.EMAIL_FORMAT:
            result = _.concat(
                result,
                fakeConstantOptions(
                    Constant.AI_AUTO.SENDER_MAIL,
                    Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.EMAIL_FORM_FIELD_PROJECT
                )
            );
            break;
        case Constant.FORM_TYPE.FORM_KNOWLEDGE:
            break;
        default:
    }

    /**
     * all file type, system allow attach
     * I'm mapping data like a form field object
     */
    const isAttachmentFieldInForm = _.some(
        fieldsListOfForm,
        i => i?.sysField === Constant.SYS_FIELD.ATTACHMENTS
    );
    const fileExtensions = fakeConstantOptions(
        Constant.AI_AUTO.FILE_EXTENSIONS,
        Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.FILE_EXTENSION,
        isAttachmentFieldInForm
    );

    /**
     * get field workFollow (status) and its items. start
     */
    if (FORM_TYPES_NEED_GET_WORK_FOLLOW_FIELD.includes(formDetail?.type)) {
        let statusFieldInForm = _.find(
            fieldsInCorporation,
            field =>
                field?.affiliationProject === projectId &&
                field?.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );

        if (!statusFieldInForm) {
            [statusFieldInForm] = await getFormFieldWithCondition(
                corporationId,
                projectId,
                Constant.FORM_USAGE.FIELD,
                Constant.FORM_TYPE.FIELD_WORKFLOW,
                Constant.FORM_DEFINITION.USER
            );
        }

        // queries items of workFollow field
        const statusListOfWorkFollowField = await getTagItemsByParentFieldId([
            statusFieldInForm?.id
        ]);

        result = _.concat(
            result,
            renameDBRecordsToStashFormatByFormType(statusListOfWorkFollowField, formDetail?.type)
        );
    }
    /**
     * get field workFollow (status) and its items. end
     */
    result = _.orderBy(result, ['sortByDefinition'], ['asc']);
    result = _.concat(result, fileExtensions);
    return result;
};

/**
 * rename tag items to format tagItemName/fieldName
 * @param {*} pureTagItems 
 * @param {*} affiliationFieldRecords 
 */
const renameTagItemToStashFormat = (pureTagItems, tagFieldRecords, projectId) => {
    return _.chain(pureTagItems)
        .map(tagItem => {
            const affiliationField = _.find(tagFieldRecords, tagField => {
                // in some case tag items of sysField, affiliationField of it is empty. So i must be get its name from SystemField.
                if (
                    Utils.isEmptyString(tagItem?.affiliationField) &&
                    tagField?.definition === Constant.FORM_DEFINITION.SYSTEM
                ) {
                    const tagItemConstantRecord = _.find(
                        systemField,
                        i => i?.id === tagItem?.sysField
                    );
                    return tagField?.sysField === tagItemConstantRecord?.affiliationField;
                }

                return tagField?.id === tagItem?.affiliationField;
            });

            const tagItemName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagItem?.name) || Utils.convertJSONDataToObject(tagItem?.name);
            let sortByDefinition = tagItem?.definition === Constant.FORM_DEFINITION.SYSTEM ? 0 : 1

            const tagFieldName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                affiliationField?.name
            );

            return {
                ...tagItem,
                name: {
                    jp: { A: 'F', text: displayTitleByItemSlashField(tagItemName, tagFieldName) }
                },
                sortDefinedKey: tagItem?.definition == Constant.FORM_DEFINITION.SYSTEM ? 0 : 1,
                sortKey: tagItemName,
                sortParentKey: tagFieldName,
                isShow: tagItem?.structure?.isShowItemInTicket && _.includes(affiliationField?.usingProjects, projectId),
                sortByDefinition
            };
        })
        .orderBy(['sortParentKey', 'sortKey' ], ['asc', 'asc'])
        .value();
};

/**
 * mapping name of ticket with field name with format. ticket title/master field name
 * @param {*} pureClusterMasterTagItems items are ticket info
 * @param {*} masterFields master field info
 * @returns 
 */
const renameMasterTagItemToStashFormat = (pureClusterMasterTagItems, masterFields) => {
    return _.chain(pureClusterMasterTagItems)
        .flatMap((clusterMasterTagItem, clusterIdx) => {
            return _.map(clusterMasterTagItem, masterTagItem => {
                const nameOfMasterItem = _.join(_.map(masterTagItem?.settingTitle, 'text'), ' ');
                const masterFieldOfThisCluster = _.nth(masterFields, clusterIdx);
                const nameOfMasterField = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    masterFieldOfThisCluster?.name
                );
                return {
                    ...masterTagItem,
                    name: {
                        jp: {
                            A: 'F',
                            text: displayTitleByItemSlashField(nameOfMasterItem, nameOfMasterField)
                        }
                    },
                    sortKey: nameOfMasterItem,
                    sortParentKey: nameOfMasterField,
                    isShow: masterTagItem?.userHasViewPermission,
                    sortByDefinition: 1
                };
            });
        })
        .orderBy(['sortParentKey', 'sortKey'], ['asc', 'asc'])
        .value();
};

/**
 * rename tag items to format tagItemName/fieldName
 * @param {*} pureRecords 
 * @param {*} formType 
 * @returns 
 */
const renameDBRecordsToStashFormatByFormType = (pureRecords, formType) => {
    let fieldName = '';
    const firstRecord = _.first(pureRecords);
    const prefixOfRecord = Utils.getPrefixOfId(firstRecord?.id);

    switch (formType) {
        case Constant.FORM_TYPE.FORM_REQ_QA:
            fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.QA_TICKET_PROJECT;
            break;
        case Constant.FORM_TYPE.FORM_REQ_NOTICE:
            fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.NOTICE_TICKET_PROJECT;
            break;
        default:
    }

    //if they are status field records
    if (prefixOfRecord === 'status') fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.STATUS;

    return _.chain(pureRecords)
        .map(record => {
            let recordName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, record?.name) || Utils.convertJSONDataToObject(record?.name);
            let sortKey = recordName
            let sortByDefinition = record?.definition === Constant.FORM_DEFINITION.SYSTEM ? 0 : 1

            if (!Utils.isEmptyString(record?.orgName))
                recordName = `${recordName} (${record?.orgName})`;

            if (prefixOfRecord === 'status') {
                const structureOfItem = Utils.convertJSONDataToObject(record?.structure)
                sortKey = structureOfItem?.no
                sortByDefinition = 0
            }

            if (prefixOfRecord === 'project') {
                sortByDefinition = 0
            }

            return {
                ...record,
                name: { jp: { A: 'F', text: displayTitleByItemSlashField(recordName, fieldName) } },
                sortKey,
                sortParentKey: record?.orgName,
                sortByDefinition
            };
        })
        .orderBy(['sortParentKey', 'sortKey'], ['asc', 'asc'])
        .value();
};

const displayTitleByItemSlashField = (itemName, fieldName) => {
    if (Utils.isEmptyString(fieldName)) return itemName;
    return `${itemName}/${fieldName}`;
};

const fakeConstantOptions = (arr, fieldName, isShow = true) => {
    return _.chain(arr)
        .map((i, idx) => {
            return {
                id: i?.id,
                name: JSON.stringify({
                    jp: {
                        A: 'F',
                        text: displayTitleByItemSlashField(i?.name, fieldName)
                    }
                }),
                definition: Constant.FORM_DEFINITION.SYSTEM,
                hitNumber: idx,
                sysField: null,
                sortKey: i?.name,
                sortParentKey: fieldName,
                isShow,
                sortByDefinition: 0
            };
        })
        .orderBy(['sortParentKey', 'sortKey'], ['asc', 'asc'])
        .value();
};

/**
 * isShowFieldEventTypeChatThread
 * show and display field_event_type_chat_thread 
 * @param {*} aiAutoSelectedData 
 * @returns 
 */
export const isShowFieldEventTypeChatThread = aiAutoSelectedData => {
    if (
        !aiAutoSelectedData ||
        Utils.isEmptyObject(aiAutoSelectedData) ||
        !aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER] ||
        Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]) ||
        !aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE] ||
        Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE])
    ) {
        return false;
    }

    if (!Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE])) {
        if (
            [
                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE
            ].includes(
                aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE][0].sysField
            )
        ) {
            return false;
        }
    }

    let currentAiEventTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
    let isSelectedChatthreadValid = currentAiEventTypeSelected.find(selectedTag =>
        [
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_OUTSIDE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_IN_PROJECT
        ].includes(selectedTag?.sysField)
    );
    
    return !Utils.isEmptyObject(isSelectedChatthreadValid);
};


/**
 * validateShowTagItemEventTypeChatThread
 * show and hide some item in field_event_type_chat_thread
 * @param {*} itemData 
 * @param {*} aiAutoSelectedData 
 * @returns 
 */
export const validateShowTagItemEventTypeChatThread = (itemData, aiAutoSelectedData = {}) => {
    if (Utils.isEmptyObject(aiAutoSelectedData)) return false;
    if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) return false;

    let isShow = false;
    let currentAiEventTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
    let currentAiTicketTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE];

    if (
        Utils.isEmptyArray(currentAiEventTypeSelected) ||
        Utils.isEmptyArray(currentAiTicketTypeSelected)
    )
        return false;

    let selectedTicketTypeItem = currentAiTicketTypeSelected[0];

    if (
        ![
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA,
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE,
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL
        ].includes(selectedTicketTypeItem.sysField)
    ) {
        return false;
    }

    switch (itemData?.sysField) {
        case Constant.AI_AUTO.CHAT_THREAD_TYPE_OPTION.THREAD_CUSTOMER:
            if (
                [
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL
                ].includes(selectedTicketTypeItem?.sysField)
            ) {
                isShow = true;
            }

            if (
                selectedTicketTypeItem?.sysField === Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE
            ) {
                let isSelectedInternalThread = currentAiEventTypeSelected.find(
                    selectedTag =>
                        selectedTag?.sysField ===
                        Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_IN_PROJECT
                );
                isShow = !Utils.isEmptyObject(isSelectedInternalThread);
            }
            break;
        case Constant.AI_AUTO.CHAT_THREAD_TYPE_OPTION.THREAD_IN_PROJECT:
            {
                let isSelectedInternalThreadType = currentAiEventTypeSelected.find(
                    selectedTag =>
                        selectedTag?.sysField ===
                        Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_IN_PROJECT
                );
                isShow = !Utils.isEmptyObject(isSelectedInternalThreadType);
            }
            break;

        case Constant.AI_AUTO.CHAT_THREAD_TYPE_OPTION.THREAD_ESCALATION:
            if (
                [
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL
                ].includes(selectedTicketTypeItem?.sysField)
            ) {
                isShow = true;
            }
            break;
        default:
            break;
    }

    return isShow;
};


/**
 * validateShowTagItemEventTrigger
 * @param {*} itemData 
 * @param {*} aiAutoSelectedData 
 */
export const validateShowTagItemEventTrigger = (itemData, aiAutoSelectedData = {}) => {
    if (Utils.isEmptyArray(itemData)) return false;

    if (itemData?.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_OUTSIDE)
        return true;

    if (Utils.isEmptyObject(aiAutoSelectedData)) return false;

    let currentAiTicketTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE];

    if (Utils.isEmptyArray(currentAiTicketTypeSelected)) return false;

    let selectedTicketTypeItem = currentAiTicketTypeSelected[0];

    return ![
        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE
    ].includes(selectedTicketTypeItem.sysField);
};